import { Component, OnInit, Input} from '@angular/core';
import { AssessmentAiStatus, FootStrikePattern, RunningCue, ImpairmentCategory, RunningDirection, TwoDimensionalAiAssessmentViewModelRead, TwoDimensionalAssessmentResult } from 'src/app/_models/generatedModels';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentService } from 'src/app/_services/generatedServices';
import { Enums } from 'src/app/_models/generatedEnums';
import { HttpErrorResponse } from '@angular/common/http';
import { ToasterService } from '../../_services/toaster.service';
import { VideoPopupComponent } from './video-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, interval, timer } from 'rxjs';

@Component({
  selector: 'two-dimensional-ai-result-details',
  templateUrl: 'two-dimensional-ai-result-details.component.html',
  styleUrls: ['two-dimensional-ai-result-details.component.scss']
})
export class TwoDimensionalAiAssessmentResultDetailsComponent implements OnInit
{
  initialized = false;
  analysis: TwoDimensionalAiAssessmentViewModelRead;
  analysisId: any;
  shareableLink: string;
  categoryScoreEnum = Enums.CategoryScoreEnum;
  footStrikePatternEnum = Enums.FootStrikePatternEnum;
  footStrikePattern = FootStrikePattern;
  speedUnitEnum = Enums.SpeedUnitEnum;
  distanceUnitEnum = Enums.DistanceUnitEnum;
  runningDirection = Enums.RunningDirectionEnum;
  assessmentAiStatusEnum = Enums.AssessmentAiStatusEnum;
  runningCueEnum = RunningCue; 
  impairmentCategoryEnum = ImpairmentCategory; 
  assessmentAiStatus = AssessmentAiStatus;

  timerSubscription?: Subscription;


  @Input()
  isCoachView: boolean = false;

  constructor(private route: ActivatedRoute, private assessmentData: AssessmentService, private router: Router, private toastr: ToasterService, private modalService: NgbModal) {}

  ngOnInit(): void {
    this.refreshData();
  }

  refreshData()
  {
    this.analysisId = this.route.snapshot.params ? this.route.snapshot.params['id'] : null;

    const isNumber = !isNaN(Number(this.analysisId));
    const isGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(this.analysisId);

    if (isNumber) {
      this.assessmentData.getTwoDimensionalAiAssessment(this.analysisId).subscribe((result) =>
      {
        this.analysis = result;
        this.initialized = true;

        if (this.analysis.status !== AssessmentAiStatus.Failed && this.analysis.status !== AssessmentAiStatus.Completed) {
          this.timerSubscription = timer(10000).subscribe(() =>
          {
            this.refreshData();
          });
        } else {
          this.clearTimer();
        }
      },
        (err: HttpErrorResponse) =>
        {
          if (err && err.error && err.error.indexOf('UnauthorizedAccessException') >= 0) {
            this.toastr.error('You do not have access to the assessment', 'Error',);
          } else {
            this.toastr.error('An error occurred while loading the assessment', 'Error');
          }

          this.router.navigate(['../../../'], { relativeTo: this.route });
        });
    } else if (isGuid) {
      this.assessmentData.getTwoDimensionalAiAssessmentByPublicId(this.analysisId).subscribe((result) =>
      {
        this.analysis = result;

        this.initialized = true;

        if (this.analysis.status !== AssessmentAiStatus.Failed && this.analysis.status !== AssessmentAiStatus.Completed) {
          this.timerSubscription = timer(10000).subscribe(() =>
          {
            this.refreshData();
          });
        } else {
          this.clearTimer();
        }
      },
        (err: HttpErrorResponse) =>
        {
          if (err && err.error && err.error.indexOf('UnauthorizedAccessException') >= 0) {
            this.toastr.error('You do not have access to the assessment', 'Error',);
          } else {
            this.toastr.error('An error occurred while loading the assessment', 'Error');
          }

          this.router.navigate(['../../../'], { relativeTo: this.route });
        });
    }
  }

  removeNegtiveSign(value: number): number
  {
    return Math.abs(value);
  }

  getLabelPelvicDrop(value: number, isLeft: boolean)
  {
    if (value < 0) {
      return isLeft ? 'lft up' : 'rgt up'
    }
    else {
      return isLeft ? 'lft down' : 'rgt down'
    }
  }

  getLabelForwardLean(value: number)
  {
    if (value < 0) {
      return 'ext'
    }
    else {
      return 'flex';
    }
  }

  getLabelHipAdduction(value: number)
  {
    if (value < 0) {
      return 'add'
    }
    else {
      return 'abd';
    }
  }

  getLabelTibialInclination(value: number)
  {
    if (value < 0) {
      return 'ext'
    }
    else {
      return 'flex';
    }
  }

  getLabelAnklePronatoin(value: number)
  {
    if (value < 0) {
      return 'sup'
    }
    else {
      return 'pron';
    }
  }

  getLabeCrossover(value: number)
  {
    if (value < 0) {
      return 'add'
    }
    else {
      return 'abd';
    }
  }

  getLabelFootInclination(value: number)
  {
    if (value < 0) {
      return 'DF'
    }
    else {
      return 'PL';
    }
  }
  

  showBackVideo()
  {
    const modalRef = this.modalService.open(VideoPopupComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
    let videoBack = this.analysis.videos.find(v => v.videoType === RunningDirection.Back);

    modalRef.componentInstance.analysisName = this.runningDirection.get(videoBack.videoType) + ": " + videoBack.video.fileNameDisplay;
    modalRef.componentInstance.videoLink = videoBack.video.assetPath;
    modalRef.componentInstance.encoded = videoBack.video.encoded;
    modalRef.componentInstance.description = videoBack.description;

    modalRef.result.then(
      (result) => { },
      (reason) => { }
    );
  }

  showSideVideo()
  {
    const modalRef = this.modalService.open(VideoPopupComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
    let videoSide = this.analysis.videos.find(v => v.videoType !== RunningDirection.Back);

    modalRef.componentInstance.analysisName = this.runningDirection.get(videoSide.videoType) + ": " + videoSide.video.fileNameDisplay;
    modalRef.componentInstance.videoLink = videoSide.video.assetPath;
    modalRef.componentInstance.encoded = videoSide.video.encoded;
    modalRef.componentInstance.description = videoSide.description;

    modalRef.result.then(
      (result) => { },
      (reason) => { }
    );
  }

  overrideScore(scoreLevel: string)
  {
    if (scoreLevel == 'G')
      return "E";
    else if (scoreLevel == 'GF')
      return "G";

    return scoreLevel;
  }

  clearTimer()
  {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  ngOnDestroy()
  {
    // Clean up timer subscription
    this.clearTimer();
  }
}
